import {
  getRootTranslator,
  getRootPluaralTranslator,
} from '@utils/get-module-translator'
import Constants from '@constants'
import moduleManager from '@modules'

import IntersectionWith from 'lodash/intersectionWith'
import IsEqual from 'lodash/isEqual'
const __rootTc = getRootPluaralTranslator()
const __rootT = getRootTranslator()

export const moduleList = () => [
  {
    key: 'automation',
    heading: __rootT('automation'),
    iconProps: {
      name: 'automation',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.automation') >= 0
    },
    items: [
      // {
      //   key: 'workflow',
      //   title: __rootT('workflow'),
      //   action: moduleManager.getModuleRoute('workflow'),
      //   disable: false,
      // },
      {
        key: 'advanced-workflow',
        title: __rootT('workflow'),
        action: moduleManager.getModuleRoute('advanced-workflow'),
        disable: false,
      },
      {
        key: 'sla',
        title: __rootT('sla'),
        disable: false,
        action: moduleManager.getModuleRoute('sla'),
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.REQUEST) >= 0,
      },
      {
        key: 'approval-workflow',
        title: `${__rootTc('approval_workflow')}`,
        action: moduleManager.getModuleRoute('approval'),
        disable: false,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.REQUEST) >= 0 ||
          allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
      {
        key: 'event-notification',
        title: __rootTc('event_notifications'),
        disable: false,
        action: moduleManager.getModuleRoute('event-notifications'),
        keywords: [
          __rootTc('app_notification'),
          __rootTc('sms_notification'),
          __rootTc('sms_gateway_configuration'),
        ],
      },
      {
        key: 'auto-assignment',
        title: __rootT('auto_assignment'),
        disable: false,
        action: moduleManager.getModuleRoute('auto-assignment'),
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.REQUEST) >= 0,
      },
      {
        key: 'scenario',
        title: __rootT('scenario'),
        disable: false,
        action: moduleManager.getModuleRoute('scenario'),
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.REQUEST) >= 0,
      },
      {
        key: 'incident-scheduler',
        title: __rootTc('incident_scheduler', 2),
        disable: false,
        action: moduleManager.getModuleRoute('auto-ticket-create'),
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.REQUEST) >= 0,
      },
      {
        key: 'task-scheduler',
        title: __rootTc('task_schedule', 2),
        disable: false,
        action: moduleManager.getModuleRoute('auto-task-create'),
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.TASK) >= 0,
      },
      {
        key: 'integration',
        title: __rootTc('integration', 2),
        action: moduleManager.getModuleRoute('integration'),
        keywords: [
          __rootTc('rest_integration'),
          __rootTc('app_integration'),
          __rootTc('plugin'),
          __rootTc('report_plugin'),
          __rootTc('chat_plugin'),
          __rootTc('webhook_endpoint'),
          __rootTc('api_credential'),
          __rootTc('api_integration'),
        ],
      },
      {
        title: `${__rootTc('custom_script')}`,
        action: moduleManager.getModuleRoute('form-rules', 'custom-script', {
          params: { moduleName: Constants.REQUEST },
        }),
        isModuleAvailable: (allAvailableModule) => {
          return (
            allAvailableModule.indexOf(Constants.REQUEST) >= 0 ||
            allAvailableModule.indexOf(Constants.CHANGE) >= 0
          )
        },
      },
    ],
  },
  {
    key: 'users',
    heading: __rootTc('user', 2),
    iconProps: {
      name: 'users-admin',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.users') >= 0
    },
    items: [
      {
        key: 'technicians',
        title: __rootTc('technician', 2),
        disable: false,
        action: moduleManager.getModuleRoute('users', undefined, {
          params: { userType: 'technician' },
        }),
        isModuleEnabledForUser(userAllowedModules) {
          return userAllowedModules.indexOf('admin.user.view') >= 0
        },
      },
      {
        key: 'requesters',
        title: __rootTc('requester', 2),
        disable: false,
        action: moduleManager.getModuleRoute('users', undefined, {
          params: { userType: 'requester' },
        }),
        isModuleEnabledForUser(userAllowedModules) {
          return userAllowedModules.indexOf('admin.user.view') >= 0
        },
      },
      {
        key: 'user-custom-fields',
        title: __rootTc('user_form'),
        disable: false,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: 'user' },
        }),
        isModuleEnabledForUser(userAllowedModules) {
          return userAllowedModules.indexOf('admin.user.custom_field') >= 0
        },
      },
      {
        key: 'technician-group',
        title: `${__rootTc('technician_groups')}`,
        disable: false,
        action: moduleManager.getModuleRoute('user-groups', undefined, {
          params: { groupType: 'technician' },
        }),
        isModuleEnabledForUser(userAllowedModules) {
          return userAllowedModules.indexOf('admin.user.users_groups') >= 0
        },
      },
      {
        key: 'requester-group',
        title: `${__rootTc('requester_groups')}`,
        disable: false,
        action: moduleManager.getModuleRoute('user-groups', undefined, {
          params: { groupType: 'requester' },
        }),
        isModuleEnabledForUser(userAllowedModules) {
          return userAllowedModules.indexOf('admin.user.users_groups') >= 0
        },
      },
      {
        key: 'roles',
        title: __rootTc('role', 2),
        disable: false,
        action: moduleManager.getModuleRoute('roles'),
        isModuleEnabledForUser(userAllowedModules) {
          return userAllowedModules.indexOf('admin.user.users_roles') >= 0
        },
      },
      {
        key: 'ldap-configurations',
        title: `${__rootT('ldap_configurations')}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'it-infrastructure',
          'ldap-configurations'
        ),
        isModuleEnabledForUser(userAllowedModules) {
          return userAllowedModules.indexOf('admin.user.users_ldap') >= 0
        },
      },
      {
        key: 'sso-configuration',
        title: `${__rootT('sso_configuration')}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'it-infrastructure',
          'sso-configuration'
        ),
        isModuleEnabledForUser(userAllowedModules) {
          return userAllowedModules.indexOf('admin.user.users_sso') >= 0
        },
      },
      {
        key: 'scim-provisioning',
        title: `${__rootT('scim_provisioning')}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'it-infrastructure',
          'scim-provisioning'
        ),
        isModuleEnabledForUser(userAllowedModules) {
          return (
            userAllowedModules.indexOf('admin.user.manage_scim_provisioning') >=
            0
          )
        },
      },
      {
        key: 'custom-sso-configuration',
        title: `${__rootT('custom_sso_configuration')}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'it-infrastructure',
          'custom-sso-configuration'
        ),
        isModuleEnabledForUser(userAllowedModules) {
          return userAllowedModules.indexOf('admin.user.users_sso') >= 0
        },
      },
      {
        key: 'custom-scope-configuration',
        title: `${__rootT('custom_scope_configuration')}`,
        disable: false,
        action: moduleManager.getModuleRoute('custom-scope-configuration'),
        isModuleEnabledForUser(userAllowedModules) {
          return userAllowedModules.indexOf('admin.user.custom_scope') >= 0
        },
        isModuleAvailable: (allAvailableModule) => {
          const isAvailable = IntersectionWith(
            [
              Constants.REQUEST,
              Constants.CHANGE,
              Constants.PROBLEM,
              Constants.RELEASE,
              Constants.ASSET,
              Constants.CMDB,
            ],
            allAvailableModule,
            IsEqual
          )
          return !!isAvailable.length
        },
      },
    ],
  },
  {
    key: 'organization',
    heading: __rootT('organization'),
    iconProps: {
      name: 'organization-admin',
    },
    colSize: 6,
    splitItems: 2,
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.organization') >= 0
    },
    items: [
      {
        key: 'account',
        title: __rootTc('account'),
        action: moduleManager.getModuleRoute('organization', 'account'),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.organization.account') >= 0,
        disable: false,
      },
      {
        key: 'branding',
        title: __rootTc('branding'),
        action: moduleManager.getModuleRoute('organization', 'branding'),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.organization.branding') >= 0,
        disable: false,
        keywords: [
          __rootTc('theme'),
          __rootTc('support_portal'),
          __rootTc('technician_portal'),
        ],
      },
      {
        key: 'departments',
        title: __rootTc('department', 2),
        disable: false,
        action: moduleManager.getModuleRoute('organization', 'department'),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.organization.departments') >= 0,
      },
      {
        key: 'locations',
        title: __rootTc('location', 2),
        disable: false,
        action: moduleManager.getModuleRoute('organization', 'location'),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.organization.locations') >= 0,
      },
      {
        key: 'business-hours',
        title: `${__rootTc('business_hours')}`,
        disable: false,
        action: moduleManager.getModuleRoute('business-hours'),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.organization.business_hours') >= 0,
      },
      {
        key: 'announcements',
        title: __rootTc('announcement', 2),
        action: moduleManager.getModuleRoute('organization', 'announcement'),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.organization.announcements') >= 0,
        disable: false,
      },
      {
        key: 'business-service',
        title: __rootTc('business_service'),
        action: moduleManager.getModuleRoute('business-service'),
        disable: false,
        isModuleAvailable: (allAvailableModule) => {
          const isAvailable = IntersectionWith(
            [
              Constants.PROBLEM,
              Constants.CHANGE,
              Constants.RELEASE,
              Constants.ASSET,
              Constants.CMDB,
            ],
            allAvailableModule,
            IsEqual
          )
          return !!isAvailable.length
        },
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.organization.business_service') >=
          0,
      },
      {
        key: 'leave-mangement',
        title: `${__rootT('leave_management')}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'organization',
          'leave-management'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.organization.leave_management') >=
          0,
        keywords: [__rootTc('leave_type'), __rootTc('leave_configuration')],
      },
      {
        key: 'system-preference',
        title: __rootTc('system_preference'),
        action: moduleManager.getModuleRoute(
          'organization',
          'system-preference'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.organization.system_preference') >=
          0,
        disable: false,
        keywords: [
          __rootTc('user_preference'),
          __rootTc('request_preference'),
          __rootTc('cmdb_preference'),
          __rootTc('asset_preference'),
          __rootTc('agent_preference'),
          __rootTc('survey_preference'),
          __rootTc('project_preference'),
          __rootTc('application_settings'),
          __rootTc('purchase_order_preference'),
          __rootTc('task_preference'),
          __rootTc('contract_preference'),
          __rootTc('search_preference'),
        ],
      },
      {
        key: 'security',
        title: __rootTc('security'),
        action: moduleManager.getModuleRoute('organization', 'security'),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.organization.security') >= 0,
        disable: false,
        keywords: [
          __rootTc('configuration_activity'),
          __rootTc('operation_activity'),
          __rootTc('password_policy'),
          __rootTc('user_security'),
          __rootTc('user_sessions'),
          __rootTc('ip_address_restriction'),
          __rootTc('email_audit'),
        ],
      },
      {
        key: 'priority',
        title: __rootTc('priority'),
        action: moduleManager.getModuleRoute('organization', 'priority'),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.organization.priority') >= 0,
        disable: false,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.REQUEST) >= 0 ||
          allAvailableModule.indexOf(Constants.PROBLEM) >= 0 ||
          allAvailableModule.indexOf(Constants.CHANGE) >= 0 ||
          allAvailableModule.indexOf(Constants.RELEASE) >= 0 ||
          allAvailableModule.indexOf(Constants.PROJECT) >= 0,
      },
      {
        key: 'impact',
        title: __rootTc('impact'),
        action: moduleManager.getModuleRoute('organization', 'impact'),
        disable: false,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.REQUEST) >= 0 ||
          allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.organization.impact') >= 0,
      },
      {
        key: 'urgency',
        title: __rootTc('urgency'),
        action: moduleManager.getModuleRoute('organization', 'urgency'),
        disable: false,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.REQUEST) >= 0,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.organization.urgency') >= 0,
      },
      {
        key: 'application-maintenance',
        title: `${__rootTc('application_maintenance')}`,
        disable: false,
        action: moduleManager.getModuleRoute('support-console'),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf(
            'admin.organization.application_maintenance'
          ) >= 0,
        keywords: [
          __rootTc('data_indexing'),
          __rootTc('language_preference'),
          __rootTc('database_backup'),
          __rootTc('data_archiving'),
          __rootTc('product_license'),
          __rootTc('log_download'),
          __rootTc('network_diagnosis'),
          __rootTc('application_stability_monitoring'),
        ],
      },
      {
        key: 'proxy-server-config',
        title: __rootTc('proxy_server_configuration'),
        action: moduleManager.getModuleRoute(
          'organization',
          'proxy-server-config'
        ),
        disable: false,
        keywords: [__rootTc('proxy_server_configuration')],
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf(
            'admin.organization.proxy_server_configuration'
          ) >= 0,
      },
      {
        key: 'msp',
        title: __rootTc('msp'),
        action: moduleManager.getModuleRoute('organization', 'msp'),
        disable: false,
        keywords: [__rootTc('company')],
        mspEnabled: (mspEnabled) => mspEnabled,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf(
            'admin.organization.managed_services_providers'
          ) >= 0,
      },
      {
        key: 'tenant-management',
        title: `${__rootTc('tenant_management')}`,
        action: moduleManager.getModuleRoute(
          'organization',
          'tenant-management'
        ),
        disable: false,
        multiTenantEnabled: (multiTenantEnabled) => multiTenantEnabled,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf(
            'admin.organization.can_manage_tenant_management'
          ) >= 0,
      },
      {
        key: 'privacy-setting',
        title: `${__rootTc('privacy_setting')}`,
        action: moduleManager.getModuleRoute('organization', 'privacy-setting'),
        disable: false,
        keywords: [
          __rootTc('privacy_regulations'),
          __rootTc('user_consent'),
          __rootTc('pii_fields'),
        ],
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf(
            'admin.organization.manage_privacy_setting'
          ) >= 0,
      },
    ],
  },
  {
    key: 'ai-management',
    heading: __rootT('ai'),
    iconProps: {
      name: 'ai',
    },
    aiEnabled: (aiEnabled) => aiEnabled,
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.ai') >= 0
    },
    items: [
      {
        key: 'ai-modesls',
        title: __rootTc('ai_model', 2),
        action: moduleManager.getModuleRoute('ai-management', 'ai-models'),
        disable: false,
      },
      {
        key: 'ai-similarity',
        title: __rootT('ai_similarity'),
        action: moduleManager.getModuleRoute('ai-management', 'ai-similarity'),
        disable: false,
        keywords: [
          __rootTc('ai_similarity_configuration'),
          `${__rootTc('embedding_params_config')}`,
        ],
      },
      {
        key: 'smart-suggestions',
        title: `${__rootT('smart_suggestions')}`,
        disable: false,
        action: moduleManager.getModuleRoute('smart-suggestions', undefined, {
          params: { moduleName: Constants.REQUEST },
          query: { type: Constants.REQUEST },
        }),
      },
    ],
  },
  {
    key: 'it_infrastructure',
    heading: __rootTc('support_channel', 2),
    iconProps: {
      name: 'support-channels-admin',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.support_channels') >= 0
    },
    items: [
      {
        key: 'emails',
        title: `${__rootTc('email', 2)}`,
        disable: false,
        keywords: [
          __rootTc('outgoing_email_server'),
          __rootTc('incoming_email_server'),
          __rootTc('email_preference'),
        ],
        action: moduleManager.getModuleRoute(
          'it-infrastructure',
          'email-server-config'
        ),
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.REQUEST) >= 0 ||
          allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
          allAvailableModule.indexOf(Constants.PROJECT) >= 0 ||
          allAvailableModule.indexOf(Constants.PATCH) >= 0 ||
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
      {
        key: 'support-portal',
        title: `${__rootT('support_portal')}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'it-infrastructure',
          'support-portal'
        ),
      },
      {
        key: 'chat',
        title: `${__rootT('chat')}`,
        disable: false,
        action: moduleManager.getModuleRoute('it-infrastructure', 'chat'),
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.REQUEST) >= 0 &&
          allAvailableModule.indexOf(Constants.CHAT) >= 0,
      },
      {
        key: 'ai-bot',
        title: `${__rootTc('ai_bot')}`,
        disable: false,
        keywords: [
          __rootTc('chat_flow'),
          __rootTc('slack_app_config'),
          __rootTc('teams_app_config'),
          __rootTc('google_chat_app_config'),
          __rootTc('telegram_app_config'),
          __rootTc('facebook_messenger_app_config'),
          __rootTc('whatsapp_config'),
          __rootTc('viber_config'),
          __rootTc('line_app_config'),
        ],
        action: moduleManager.getModuleRoute('it-infrastructure', 'ai-bot'),
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.REQUEST) >= 0 &&
          allAvailableModule.indexOf(Constants.CHAT) >= 0 &&
          allAvailableModule.indexOf(Constants.CHATBOT) >= 0,
      },
      // @TODO enable in next release
      // {
      //   title: `${__rootT('telephony')}`,
      //   disable: false,
      //   action: moduleManager.getModuleRoute('contactops'),
      //   isModuleAvailable: (allAvailableModule) =>
      //     allAvailableModule.indexOf(Constants.REQUEST) >= 0,
      // },
    ],
  },
  {
    key: 'request_management',
    heading: `${__rootTc('request_management')}`,
    iconProps: {
      name: 'ticket-alt',
    },
    colSize: 6,
    splitItems: 2,
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.request_management') >= 0
    },
    isModuleAvailable: (allAvailableModule) =>
      allAvailableModule.indexOf(Constants.REQUEST) >= 0,
    items: [
      {
        key: 'request-form',
        title: `${__rootT('module_form', { module: __rootTc('request') })}`,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: Constants.REQUEST },
        }),
        disable: false,
      },
      {
        key: 'request-status',
        title: `${__rootT('module_status', { module: __rootTc('request') })}`,
        action: moduleManager.getModuleRoute('status', undefined, {
          params: { moduleName: Constants.REQUEST },
          query: { type: Constants.REQUEST },
        }),
      },
      {
        key: 'priority-matrix',
        title: __rootT('priority_matrix'),
        action: moduleManager.getModuleRoute('request-management', 'matrix'),
        disable: false,
      },
      {
        key: 'request-feedback',
        title: `${__rootTc('request_feedback_setting')} `,
        action: moduleManager.getModuleRoute(
          'request-management',
          'feedback_setting'
        ),
        disable: false,
      },
      {
        key: 'response-template',
        title: __rootTc('response_template', 2),
        action: moduleManager.getModuleRoute('response-template'),
        disable: false,
      },
      {
        key: 'email-command-settings',
        title: __rootTc('email_command_settings'),
        action: moduleManager.getModuleRoute(
          'request-management',
          'email_command_settings'
        ),
        disable: false,
      },
      {
        key: 'request-category',
        title: `${__rootTc('request_category', 2)}`,
        action: moduleManager.getModuleRoute('category', undefined, {
          params: { moduleName: Constants.REQUEST },
          query: { type: Constants.REQUEST },
        }),
        disable: false,
      },
      {
        key: 'request-template',
        title: `${__rootTc('request_template', 2)} `,
        action: moduleManager.getModuleRoute('templates', undefined, {
          params: { moduleName: Constants.REQUEST },
          query: { type: Constants.REQUEST },
        }),
        disable: false,
      },
      {
        key: 'feedback-form',
        title: `${__rootTc('feedback_form')}`,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: 'feedback' },
        }),
        disable: false,
      },
      {
        key: 'incidnet-custom-rules',
        title: `${__rootTc('incident_custom_rules')}`,
        action: moduleManager.getModuleRoute('custom-rules', undefined, {
          params: { moduleName: Constants.REQUEST },
          query: { type: Constants.REQUEST },
        }),
        disable: false,
      },
      {
        key: 'service-request-custom-rules',
        title: `${__rootT('module_custom_rules', {
          module: __rootTc('service_request'),
        })}`,
        action: moduleManager.getModuleRoute('custom-rules', undefined, {
          params: { moduleName: Constants.SERVICE_CATALOG },
          query: { type: Constants.SERVICE_CATALOG },
        }),
        disable: false,
        isModuleEnabledForUser(userAllowedModules) {
          return userAllowedModules.indexOf('admin.service_catalog') >= 0
        },
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.SERVICE_CATALOG) >= 0,
      },
      {
        key: 'request-form-rules',
        title: `${__rootT('module_form_rule', {
          module: __rootTc('request'),
        })}`,
        action: moduleManager.getModuleRoute('form-rules', undefined, {
          params: { moduleName: Constants.REQUEST },
        }),
        disable: false,
      },
      {
        key: 'source',
        title: __rootTc('source'),
        action: moduleManager.getModuleRoute('request-management', 'source'),
        disable: false,
      },
      {
        key: 'change-model',
        title: `${__rootT('module_model', { module: __rootTc('request') })}`,
        action: moduleManager.getModuleRoute('change-model', undefined, {
          params: { moduleName: 'request' },
        }),
        disable: false,
      },
      {
        key: 'print-template',
        title: `${__rootTc('print_template')}`,
        action: moduleManager.getModuleRoute('print-template', '', {
          params: { moduleName: Constants.REQUEST },
          query: { type: Constants.REQUEST },
        }),
      },
    ],
  },
  {
    key: 'service_catalog',
    heading: __rootT('service_catalog'),
    iconProps: {
      name: 'request-service',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.service_catalog') >= 0
    },
    isModuleAvailable: (allAvailableModule) =>
      allAvailableModule.indexOf(Constants.SERVICE_CATALOG) >= 0,
    items: [
      {
        key: 'service-catalog',
        title: __rootT('service_catalog'),
        action: moduleManager.getModuleRoute('service-catalog'),
        disable: false,
      },
    ],
  },
  {
    key: 'problem_management',
    heading: `${__rootTc('problem')} ${__rootT('management')}`,
    iconProps: {
      name: 'problem',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.problem_management') >= 0
    },
    isModuleAvailable: (allAvailableModule) =>
      allAvailableModule.indexOf(Constants.PROBLEM) >= 0,
    items: [
      {
        key: 'problem-form',
        title: `${__rootT('module_form', { module: __rootTc('problem') })}`,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: 'problem' },
        }),
        disable: false,
      },
      {
        key: 'problem-category',
        title: `${__rootT('module_category', {
          module: __rootTc('problem'),
        })}`,
        action: moduleManager.getModuleRoute('category', undefined, {
          params: { moduleName: 'problem' },
          query: { type: 'problem' },
        }),
        disable: false,
      },
      {
        key: 'problem-status',
        title: `${__rootT('module_status', { module: __rootTc('problem') })}`,
        action: moduleManager.getModuleRoute('status', undefined, {
          params: { moduleName: 'problem' },
          query: { type: 'problem' },
        }),
      },
      {
        key: 'problem-form-rules',
        title: `${__rootT('module_form_rule', {
          module: __rootTc('problem'),
        })}`,
        action: moduleManager.getModuleRoute('form-rules', undefined, {
          params: { moduleName: Constants.PROBLEM },
        }),
        disable: false,
      },
      {
        key: 'problem-template',
        title: `${__rootT('module_template', {
          module: __rootTc('problem'),
        })}`,
        action: moduleManager.getModuleRoute('templates', undefined, {
          params: { moduleName: 'problem' },
          query: { type: 'problem' },
        }),
        disable: false,
      },
      {
        key: 'problem-custom-rules',
        title: `${__rootT('module_custom_rules', {
          module: __rootTc('problem'),
        })}`,
        action: moduleManager.getModuleRoute('custom-rules', undefined, {
          params: { moduleName: 'problem' },
          query: { type: 'problem' },
        }),
        disable: false,
      },
      {
        key: 'change-model',
        title: `${__rootT('module_model', { module: __rootTc('problem') })}`,
        action: moduleManager.getModuleRoute('change-model', undefined, {
          params: { moduleName: 'problem' },
        }),
        disable: false,
      },
    ],
  },
  {
    key: 'change_management',
    heading: `${__rootTc('change_management')}`,
    colSize: 6,
    splitItems: 2,
    iconProps: {
      name: 'change',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.change_management') >= 0
    },
    isModuleAvailable: (allAvailableModule) =>
      allAvailableModule.indexOf(Constants.CHANGE) >= 0,
    items: [
      {
        key: 'change-form',
        title: `${__rootT('module_form', { module: __rootTc('change') })}`,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: 'change' },
        }),
        disable: false,
      },
      {
        key: 'change-status',
        title: `${__rootT('module_status', { module: __rootTc('change') })}`,
        action: moduleManager.getModuleRoute('status', undefined, {
          params: { moduleName: 'change' },
          query: { type: 'change' },
        }),
      },
      {
        key: 'change-custom-rules',
        title: `${__rootT('module_custom_rules', {
          module: __rootTc('change'),
        })}`,
        action: moduleManager.getModuleRoute('custom-rules', undefined, {
          params: { moduleName: 'change' },
          query: { type: 'change' },
        }),
        disable: false,
      },
      {
        key: 'change-form-rules',
        title: `${__rootT('module_form_rule', {
          module: __rootTc('change'),
        })}`,
        action: moduleManager.getModuleRoute('form-rules', undefined, {
          params: { moduleName: Constants.CHANGE },
        }),
        disable: false,
      },
      {
        key: 'change-type',
        title: `${__rootTc('change_type', 2)}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'change-management',
          'change-type'
        ),
      },
      {
        key: 'target-environment',
        title: `${__rootTc('target_environment')}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'change-management',
          'target-environment'
        ),
      },
      {
        key: 'change-category',
        title: `${__rootT('module_category', { module: __rootTc('change') })}`,
        action: moduleManager.getModuleRoute('category', undefined, {
          params: { moduleName: 'change' },
          query: { type: 'change' },
        }),
        disable: false,
      },
      {
        key: 'change-template',
        title: `${__rootT('module_template', { module: __rootTc('change') })}`,
        action: moduleManager.getModuleRoute('templates', undefined, {
          params: { moduleName: 'change' },
          query: { type: 'change' },
        }),
        disable: false,
      },
      {
        key: 'change-risk',
        title: `${__rootTc('change_risk')}`,
        disable: false,
        action: moduleManager.getModuleRoute('change-management', 'risk-type'),
      },
      {
        key: 'change-reason',
        title: `${__rootTc('change_reason')}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'change-management',
          'reason-type'
        ),
      },
      {
        key: 'change-model',
        title: `${__rootT('module_model', { module: __rootTc('change') })}`,
        action: moduleManager.getModuleRoute('change-model', undefined, {
          params: { moduleName: 'change' },
        }),
        disable: false,
      },
      {
        key: 'print-template',
        title: `${__rootTc('print_template')}`,
        action: moduleManager.getModuleRoute('print-template', '', {
          params: { moduleName: Constants.CHANGE },
          query: { type: Constants.CHANGE },
        }),
      },
    ],
  },
  {
    key: 'release_management',
    heading: `${__rootTc('release_management')}`,
    // colSize: 6,
    // splitItems: 2,
    iconProps: {
      name: 'box-full',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.release_management') >= 0
    },
    isModuleAvailable: (allAvailableModule) =>
      allAvailableModule.indexOf(Constants.RELEASE) >= 0,
    items: [
      {
        key: 'release-form',
        title: `${__rootT('module_form', { module: __rootTc('release') })}`,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: Constants.RELEASE },
        }),
      },
      {
        key: 'release-status',
        title: `${__rootT('module_status', { module: __rootTc('release') })}`,
        action: moduleManager.getModuleRoute('status', undefined, {
          params: { moduleName: Constants.RELEASE },
          query: { type: Constants.RELEASE },
        }),
      },
      {
        key: 'release-category',
        title: `${__rootT('module_category', {
          module: __rootTc('release'),
        })}`,
        action: moduleManager.getModuleRoute('category', undefined, {
          params: { moduleName: 'release' },
          query: { type: 'release' },
        }),
        disable: false,
      },
      {
        key: 'release-type',
        title: `${__rootTc('release_type', 2)}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'release-management',
          'release-type'
        ),
      },
      {
        key: 'release-risk',
        title: `${__rootTc('release_risk')}`,
        disable: false,
        action: moduleManager.getModuleRoute('release-management', 'risk-type'),
      },
      {
        key: 'release-reason',
        title: `${__rootTc('release_reason')}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'release-management',
          'reason-type'
        ),
      },
      {
        key: 'release-template',
        title: `${__rootT('module_template', {
          module: __rootTc('release'),
        })}`,
        action: moduleManager.getModuleRoute('templates', undefined, {
          params: { moduleName: 'release' },
          query: { type: 'release' },
        }),
        disable: false,
      },
      {
        key: 'release-custom-rules',
        title: `${__rootT('module_custom_rules', {
          module: __rootTc('release'),
        })}`,
        action: moduleManager.getModuleRoute('custom-rules', undefined, {
          params: { moduleName: 'release' },
          query: { type: 'release' },
        }),
        disable: false,
      },
      {
        key: 'change-model',
        title: `${__rootT('module_model', { module: __rootTc('release') })}`,
        action: moduleManager.getModuleRoute('change-model', undefined, {
          params: { moduleName: 'release' },
        }),
        disable: false,
      },
    ],
  },
  {
    key: 'asset_management',
    heading: `${__rootTc('asset_management')}`,
    colSize: 6,
    splitItems: 2,
    iconProps: {
      name: 'laptop',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.asset_management') >= 0
    },
    isModuleAvailable: (allAvailableModule) => {
      return allAvailableModule.indexOf(Constants.ASSET) >= 0
    },
    items: [
      {
        key: 'asset-types',
        title: `${__rootTc('asset_type', 2)}`,
        disable: false,
        action: moduleManager.getModuleRoute('asset-management', 'assettype', {
          query: { moduleName: Constants.ASSET, type: 'assettype' },
        }),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'asset-status',
        title: `${__rootT('module_status', { module: __rootTc('asset') })}`,
        action: moduleManager.getModuleRoute('status', undefined, {
          params: { moduleName: Constants.ASSET },
          query: { type: Constants.ASSET },
        }),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'asset-custom-rules',
        title: `${__rootT('module_custom_rules', {
          module: __rootTc('asset'),
        })}`,
        action: moduleManager.getModuleRoute('custom-rules', undefined, {
          params: { moduleName: Constants.ASSET },
          query: { type: Constants.ASSET },
        }),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'asset-form-rules',
        title: `${__rootT('module_form_rule', { module: __rootTc('asset') })}`,
        action: moduleManager.getModuleRoute('form-rules', undefined, {
          params: { moduleName: Constants.ASSET },
        }),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'asset-group',
        title: `${__rootT('module_group', { module: __rootTc('asset') })}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'asset-group',
          { query: { moduleName: Constants.ASSET } }
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'software-category',
        title: `${__rootT('module_category', {
          module: __rootTc('software'),
        })}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'software-category'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'software-type',
        title: `${__rootTc('software_type', 2)}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'software-type'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'software-rules',
        title: `${__rootTc('software_rule', 2)}`,
        disable: false,
        keywords: [
          __rootTc('software_type_settings'),
          __rootTc('prohibited_software_rule'),
          __rootTc('mandatory_software'),
          __rootTc('software_normalization_rule'),
          __rootTc('auto_uninstallation_policy'),
        ],
        action: moduleManager.getModuleRoute(
          'asset-management',
          'software-rules'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'software-license-custom-fields',
        title: `${__rootT('module_custom_fields', {
          module: __rootTc('software_license'),
        })}`,
        disable: false,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: Constants.SOFTWARE_LICENSE },
        }),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'rdp-configurations',
        title: __rootTc('rdp_configuration', 2),
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'rdp-configuration'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'barcode',
        title: `${__rootTc('barcode')}`,
        disable: false,
        action: moduleManager.getModuleRoute('asset-management', 'barcode'),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'qrcode',
        title: `${__rootTc('qrcode')}`,
        disable: false,
        action: moduleManager.getModuleRoute('asset-management', 'qrcode'),
        keywords: [__rootTc('qr_code_preference'), __rootTc('label_template')],
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        title: `${__rootTc('asset_movement', 2)}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'asset-movement'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'asset-movement-form',
        title: `${__rootT('module_custom_fields', {
          module: __rootTc('asset_movement'),
        })}`,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: Constants.ASSET_MOVEMENT },
        }),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        title: `${__rootTc('manage_baseline', 2)}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'manage-baseline'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'wake-on-lan',
        title: __rootTc('wake_on_lan'),
        disable: false,
        action: moduleManager.getModuleRoute('asset-management', 'wake-on-lan'),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'asset-configuration',
        title: __rootTc('asset_configuration'),
        disable: false,
        keywords: [__rootTc('usb_configuration')],
        action: moduleManager.getModuleRoute(
          'asset-management',
          'asset-configuration'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'deployment-policy',
        title: `${__rootTc('deployment_policy', 2)}`,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'deployment-policy'
        ),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0 &&
          allAvailableModule.indexOf(Constants.PATCH) === -1,
      },
      {
        key: 'geolocation',
        title: __rootTc('geolocation'),
        disable: false,
        action: moduleManager.getModuleRoute('asset-management', 'geolocation'),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'print-template',
        title: `${__rootTc('print_template')}`,
        keywords: [
          `${__rootTc('asset_movement')} ${__rootTc('print_template')}`,
        ],
        action: moduleManager.getModuleRoute('print-template', '', {
          params: { moduleName: Constants.ASSET },
          query: { type: Constants.ASSET },
        }),
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
      {
        key: 'asset-category',
        title: `${__rootT('module_category', { module: __rootTc('asset') })}`,
        action: moduleManager.getModuleRoute('category', undefined, {
          params: { moduleName: Constants.ASSET },
          query: { type: Constants.ASSET },
        }),
        disable: false,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0,
      },
    ],
  },
  {
    key: 'supplier_management',
    heading: `${__rootTc('supplier_management')}`,
    iconProps: {
      name: 'supplier-management',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.supplier_management') >= 0
    },
    isModuleAvailable: (allAvailableModule) => {
      return (
        allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
        allAvailableModule.indexOf(Constants.CMDB) >= 0
      )
    },
    items: [
      {
        key: 'manufacturer-catalog',
        title: __rootTc('manufacturer_catalog'),
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'manufacturer-catalog'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_catalogs') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
      {
        key: 'product-type',
        title: __rootTc('product_type', 2),
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'product-type'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_catalogs') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
      {
        key: 'product-catalog',
        title: __rootTc('product_catalog'),
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'product-catalog'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_catalogs') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
      {
        key: 'product-custom-fields',
        title: `${__rootT('module_custom_fields', {
          module: __rootTc('product'),
        })}`,
        disable: false,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: Constants.PRODUCT },
        }),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_catalogs') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
      {
        key: 'vendor-catalog',
        title: __rootTc('vendor_catalog'),
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'vendor-catalog'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_catalogs') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
      {
        key: 'vendor-custom-fields',
        title: `${__rootT('module_custom_fields', {
          module: __rootTc('vendor'),
        })}`,
        disable: false,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: Constants.VENDOR },
        }),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_catalogs') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
      {
        key: 'warranty-sync',
        title: `${__rootTc('warranty_sync')}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'warranty-sync'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.warranty_sync') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
    ],
  },
  {
    key: 'ci_management',
    heading: `${__rootTc('cmdb')}`,
    iconProps: {
      name: 'ci',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.cmdb_management') >= 0
    },
    isModuleAvailable: (allAvailableModule) => {
      return allAvailableModule.indexOf(Constants.CMDB) >= 0
    },
    items: [
      {
        key: 'ci-types',
        title: `${__rootTc('ci_type', 2)}`,
        disable: false,
        action: moduleManager.getModuleRoute('asset-management', 'citype', {
          query: { moduleName: Constants.CMDB, type: 'citype' },
        }),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.cmdb_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
      {
        key: 'ci-status',
        title: `${__rootT('module_status', { module: __rootTc('ci') })}`,
        action: moduleManager.getModuleRoute('status', undefined, {
          params: { moduleName: Constants.CMDB },
          query: { type: Constants.CMDB },
        }),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.cmdb_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
      {
        key: 'ci-group',
        title: `${__rootTc('ci_group', 2)}`,
        disable: false,
        action: moduleManager.getModuleRoute('asset-management', 'ci-group', {
          query: { moduleName: Constants.CMDB },
        }),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.cmdb_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
      {
        key: 'ci-custom-rules',
        title: `${__rootT('module_custom_rules', { module: __rootTc('ci') })}`,
        action: moduleManager.getModuleRoute('custom-rules', undefined, {
          params: {
            moduleName: Constants.ASSET,
            subModuleName: Constants.CMDB,
          },
          query: { type: Constants.ASSET },
        }),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.cmdb_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
    ],
  },
  {
    key: 'discovery_and_agents',
    heading: `${__rootTc('discovery_and_agents')}`,
    iconProps: {
      name: 'discovery-agent',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return (
        userAllowedModules.indexOf('admin.patch_management') >= 0 ||
        userAllowedModules.indexOf('admin.asset_discovery') >= 0 ||
        userAllowedModules.indexOf('admin.asset_management') >= 0 ||
        userAllowedModules.indexOf('admin.cmdb_management') >= 0 ||
        userAllowedModules.indexOf('admin.agent_management') >= 0
      )
    },
    isModuleAvailable: (allAvailableModule) => {
      return (
        allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
        allAvailableModule.indexOf(Constants.CMDB) >= 0 ||
        allAvailableModule.indexOf(Constants.PATCH) >= 0
      )
    },
    items: [
      {
        key: 'discovery',
        title: `${__rootTc('discovery')}`,
        disable: false,
        keywords: [
          __rootTc('discovery_service'),
          __rootTc('network_scan'),
          __rootTc('cloud_network'),
          __rootTc('private_cloud_network'),
          __rootTc('domain_scan'),
          __rootTc('sccm_scan'),
          __rootTc('dns_configuration'),
          __rootTc('discovery_preference_rule'),
        ],
        action: moduleManager.getModuleRoute('asset-management', 'discovery'),
        isModuleEnabledForUser: (userAllowedModules) => {
          return userAllowedModules.indexOf('admin.asset_discovery') >= 0
        },
        isModuleAvailable: (allAvailableModule) => {
          return (
            allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
            allAvailableModule.indexOf(Constants.CMDB) >= 0
          )
        },
      },
      {
        key: 'agent',
        title: `${__rootTc('agent')}`,
        disable: false,
        keywords: [
          __rootTc('agent_installation'),
          __rootTc('agent_build'),
          __rootTc('agent_installation_history'),
          __rootTc('discovery_agent'),
          __rootTc('mobile_agent'),
        ],
        action: moduleManager.getModuleRoute('asset-management', 'agent'),
        isModuleEnabledForUser: (userAllowedModules) => {
          return (
            userAllowedModules.indexOf('admin.asset_discovery') >= 0 ||
            userAllowedModules.indexOf('admin.patch_management') >= 0 ||
            userAllowedModules.indexOf('admin.agent_management') >= 0
          )
        },
        isModuleAvailable: (allAvailableModule) => {
          return (
            allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
            allAvailableModule.indexOf(Constants.CMDB) >= 0 ||
            allAvailableModule.indexOf(Constants.PATCH) >= 0
          )
        },
      },
      {
        key: 'credentials',
        title: `${__rootTc('credentials')}`,
        disable: false,
        action: moduleManager.getModuleRoute('asset-management', 'credentials'),
        isModuleEnabledForUser: (userAllowedModules) => {
          return (
            userAllowedModules.indexOf('admin.asset_discovery') >= 0 ||
            userAllowedModules.indexOf('admin.agent_management') >= 0
          )
        },
        isModuleAvailable: (allAvailableModule) => {
          return (
            allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
            allAvailableModule.indexOf(Constants.CMDB) >= 0 ||
            allAvailableModule.indexOf(Constants.PATCH) >= 0
          )
        },
      },
      {
        key: 'discovery_pattern',
        title: `${__rootTc('discovery_pattern')}`,
        disable: false,
        action: moduleManager.getModuleRoute('workflow-definition', ''),
        isModuleEnabledForUser: (userAllowedModules) => {
          return userAllowedModules.indexOf('admin.asset_discovery') >= 0
        },
        isModuleAvailable: (allAvailableModule) => {
          return (
            allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
            allAvailableModule.indexOf(Constants.CMDB) >= 0
          )
        },
      },
      {
        key: 'snmp-custom-properties',
        title: `${__rootTc('snmp_custom_properties')}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'snmp-custom-properties'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0 ||
          userAllowedModules.indexOf('admin.cmdb_management') >= 0 ||
          userAllowedModules.indexOf('admin.asset_discovery') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
      {
        key: 'ip-range-location',
        title: `${__rootTc('ip_range_location')}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'ipRangeLocation'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_discovery') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
      {
        key: 'relationship-type',
        title: __rootTc('relationship_type', 2),
        disable: false,
        action: moduleManager.getModuleRoute(
          'asset-management',
          'asset-relationship-types'
        ),
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.asset_management') >= 0 ||
          userAllowedModules.indexOf('admin.cmdb_management') >= 0 ||
          userAllowedModules.indexOf('admin.asset_discovery') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.ASSET) >= 0 ||
          allAvailableModule.indexOf(Constants.CMDB) >= 0,
      },
    ],
  },
  {
    key: 'contract_management',
    heading: `${__rootTc('contract_management')}`,
    iconProps: {
      name: 'handshake',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.contract_management') >= 0
    },
    isModuleAvailable: (allAvailableModule) =>
      allAvailableModule.indexOf(Constants.CONTRACT) >= 0,
    items: [
      {
        key: 'contract-type',
        title: `${__rootTc('contract_type', 2)}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'contract-management',
          'contract-types'
        ),
      },
      {
        key: 'contract-custom-fields',
        title: `${__rootT('module_custom_fields', {
          module: __rootTc('contract'),
        })}`,
        disable: false,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: 'contract' },
        }),
      },
    ],
  },
  {
    key: 'purchase_management',
    heading: `${__rootTc('purchase_management')}`,
    // colSize: 6,
    // splitItems: 2,
    iconProps: {
      name: 'shopping-cart',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.purchase_management') >= 0
    },
    isModuleAvailable: (allAvailableModule) =>
      allAvailableModule.indexOf(Constants.PURCHASE) >= 0,
    items: [
      {
        key: 'purchase-custom-fields',
        title: `${__rootT('module_custom_fields', {
          module: __rootTc('purchase'),
        })}`,
        disable: false,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: Constants.PURCHASE },
        }),
      },
      {
        key: 'purchase-price-fields',
        title: `${__rootT('module_price_fields', {
          module: __rootTc('purchase'),
        })}`,
        disable: false,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: Constants.PURCHASE },
          query: { fieldType: 'price' }, // do not change query fieldType
        }),
      },
      {
        key: 'gl-code',
        title: `${__rootTc('gl_code')}`,
        disable: false,
        action: moduleManager.getModuleRoute('purchase-management', 'gl-code'),
      },
      {
        key: 'cost-center',
        title: `${__rootTc('cost_center')}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'purchase-management',
          'cost-center'
        ),
      },
      {
        key: 'purchase-custom-rules',
        title: `${__rootT('module_custom_rules', {
          module: __rootTc('purchase'),
        })}`,
        action: moduleManager.getModuleRoute('custom-rules', undefined, {
          params: { moduleName: Constants.PURCHASE },
          query: { type: Constants.PURCHASE },
        }),
        disable: false,
      },
      {
        key: 'print-template',
        title: `${__rootTc('print_template')}`,
        action: moduleManager.getModuleRoute('print-template', '', {
          params: { moduleName: Constants.PURCHASE },
          query: { type: Constants.PURCHASE },
        }),
      },
      {
        key: 'address',
        title: `${__rootTc('address')} `,
        action: moduleManager.getModuleRoute('purchase-management', 'address'),
        disable: false,
      },
    ],
  },
  {
    key: 'patch_management',
    heading: __rootT('patch_management'),
    iconProps: {
      name: 'shield-alt',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return (
        userAllowedModules.indexOf('admin.patch_management') >= 0 ||
        userAllowedModules.indexOf('admin.deployment') >= 0
      )
    },
    isModuleAvailable: (allAvailableModule) =>
      allAvailableModule.indexOf(Constants.PATCH) >= 0 ||
      allAvailableModule.indexOf(Constants.DEPLOYMENT) >= 0,
    items: [
      {
        key: 'patch-settings',
        title: `${__rootTc('patch_settings')}`,
        action: moduleManager.getModuleRoute(
          'patch-management',
          'patch-settings'
        ),
        disable: false,
        keywords: [
          __rootTc('update_patch_database'),
          __rootTc('patch_storage_config'),
          __rootTc('patch_approval_policy'),
          __rootTc('file_server'),
          `${__rootT('module_notification', {
            module: __rootTc('deployment'),
          })}`,
        ],
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.patch_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.PATCH) >= 0,
      },
      {
        key: 'access-controls',
        title: `${__rootTc('access_controls')}`,
        action: moduleManager.getModuleRoute(
          'patch-management',
          'access-controls'
        ),
        disable: false,
        keywords: [
          // `${__rootTc('proxy')} ${__rootTc('server')} ${__rootTc(
          //   'configuration'
          // )}`,
          __rootTc('bandwidth_utilization'),
          __rootTc('relay_server_settings'),
        ],
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.patch_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.PATCH) >= 0,
      },
      {
        key: 'remote-office',
        title: `${__rootTc('remote_office', 2)}`,
        action: moduleManager.getModuleRoute(
          'patch-management',
          'remote-office'
        ),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.patch_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.PATCH) >= 0,
      },
      {
        key: 'endpoints-scope',
        title: `${__rootT('module_scope', { module: __rootTc('endpoints') })}`,
        action: moduleManager.getModuleRoute(
          'patch-management',
          'endpoints-scope'
        ),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.patch_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.PATCH) >= 0,
      },
      {
        key: 'computer-group',
        title: `${__rootT('module_group', { module: __rootTc('computer') })}`,
        action: moduleManager.getModuleRoute(
          'patch-management',
          'computer-groups'
        ),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.patch_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.PATCH) >= 0,
      },
      {
        key: 'system-health-settings',
        title: `${__rootTc('system_health_settings')}`,
        action: moduleManager.getModuleRoute(
          'patch-management',
          'system-health-settings'
        ),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.patch_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.PATCH) >= 0,
      },
      {
        key: 'deployment-policy',
        title: `${__rootTc('deployment_policy', 2)}`,
        action: moduleManager.getModuleRoute(
          'patch-management',
          'deployment-policy'
        ),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.patch_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.PATCH) >= 0,
      },
      {
        key: 'decline-patch',
        title: `${__rootTc('decline_patch', 2)}`,
        action: moduleManager.getModuleRoute(
          'patch-management',
          'decline-patch'
        ),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.patch_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.PATCH) >= 0,
      },
      {
        key: 'packages',
        title: `${__rootTc('packages', 2)}`,
        action: moduleManager.getModuleRoute('packages'),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.deployment') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.DEPLOYMENT) >= 0,
      },
      {
        key: 'registry-template',
        title: `${__rootTc('registry_template', 2)}`,
        action: moduleManager.getModuleRoute('registry-template'),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.deployment') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.DEPLOYMENT) >= 0,
      },
      {
        key: 'red-hat-patch-settings',
        title: `${__rootTc('red_hat_patch_settings')}`,
        action: moduleManager.getModuleRoute(
          'patch-management',
          'red-hat-patch-settings'
        ),
        disable: false,
        isModuleEnabledForUser: (userAllowedModules) =>
          userAllowedModules.indexOf('admin.patch_management') >= 0,
        isModuleAvailable: (allAvailableModule) =>
          allAvailableModule.indexOf(Constants.PATCH) >= 0,
      },
    ],
  },
  {
    key: 'project_management',
    heading: __rootT('project_management'),
    iconProps: {
      name: 'project-diagram',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.project_management') >= 0
    },
    isModuleAvailable: (allAvailableModule) =>
      allAvailableModule.indexOf(Constants.PROJECT) >= 0,
    items: [
      {
        key: 'project-roles',
        title: `${__rootT('module_role', { module: __rootTc('project') })}`,
        action: moduleManager.getModuleRoute('roles', undefined, {
          query: { moduleName: 'project' },
        }),
        hasProjectRequesterLicense: (hasProjectRequesterLicense) =>
          hasProjectRequesterLicense,
        disable: false,
      },
      {
        key: 'project-form',
        title: `${__rootT('module_form', { module: __rootTc('project') })}`,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: 'project' },
        }),
        disable: false,
      },
      {
        key: 'project-risk',
        title: `${__rootTc('project_risk')}`,
        disable: false,
        action: moduleManager.getModuleRoute('project-management', 'risk-type'),
      },
      {
        key: 'project-type',
        title: `${__rootTc('project_type', 2)}`,
        disable: false,
        action: moduleManager.getModuleRoute(
          'project-management',
          'project-type'
        ),
      },
      {
        key: 'project-custom-rules',
        title: `${__rootT('module_custom_rules', {
          module: __rootTc('project'),
        })}`,
        action: moduleManager.getModuleRoute('custom-rules', undefined, {
          params: { moduleName: 'project' },
          query: { type: 'project' },
        }),
        disable: false,
      },
    ],
  },
  {
    key: 'knowledge_management',
    heading: __rootT('knowledge_management'),
    iconProps: {
      name: 'lightbulb-on',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.knowledge_management') >= 0
    },
    items: [
      {
        key: 'knowledge-custom-rules',
        title: `${__rootTc('knowledge_custom_rule', 2)}`,
        action: moduleManager.getModuleRoute('custom-rules', undefined, {
          params: { moduleName: Constants.KNOWLEDGE },
          query: { type: Constants.KNOWLEDGE },
        }),
        disable: false,
      },
    ],
  },
  {
    key: 'user_survey',
    heading: __rootTc('user_survey'),
    iconProps: {
      name: 'user-survey-admin',
    },
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.user_survey_management') >= 0
    },
    items: [
      {
        key: 'user-survey',
        title: `${__rootTc('user_survey', 2)}`,
        action: moduleManager.getModuleRoute('user-survey'),
        disable: false,
      },
      {
        key: 'schedule-survey',
        title: `${__rootTc('schedule_survey')}`,
        action: moduleManager.getModuleRoute('user-survey', 'schedule-survey'),
        disable: false,
      },
    ],
  },
  {
    key: 'task_management',
    heading: `${__rootTc('task_management')}`,
    iconProps: {
      name: 'tasks',
    },
    isModuleAvailable: (allAvailableModule) =>
      allAvailableModule.indexOf(Constants.TASK) >= 0,
    isModuleEnabledForUser(userAllowedModules) {
      return userAllowedModules.indexOf('admin.task_management') >= 0
    },
    items: [
      {
        key: 'task-type',
        title: `${__rootTc('task_type', 2)}`,
        action: moduleManager.getModuleRoute('organization', 'task-type'),
        disable: false,
      },
      {
        key: 'task-form',
        title: `${__rootT('module_form', { module: __rootTc('task') })}`,
        action: moduleManager.getModuleRoute('form', undefined, {
          params: { moduleName: Constants.TASK },
        }),
        disable: false,
      },
      {
        key: 'task-form-rules',
        title: `${__rootT('module_form_rule', { module: __rootTc('task') })}`,
        action: moduleManager.getModuleRoute('form-rules', undefined, {
          params: { moduleName: Constants.TASK },
        }),
        disable: false,
      },
      {
        key: 'task-status',
        title: `${__rootTc('task')} ${__rootTc('status')}`,
        action: moduleManager.getModuleRoute('status', undefined, {
          params: { moduleName: Constants.TASK },
          query: { type: Constants.TASK },
        }),
      },
    ],
  },
]
